module.exports = __webpack_public_path__ + "static/media/alchemist.f134dc6b.jpg";